import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/main';
import VueCookies from 'vue-cookies';
import Meta from 'vue-meta';
import dateFormat from 'dateformat';
import Notifications from 'vue-notification';
import numberFormat from 'number_format-php';
import VModal from 'vue-js-modal';
import Helper from "./classes/Helper";
import moment from "moment";
import VueSocketIO from 'vue-socket.io';
import SocketIO from 'socket.io-client';

Vue.use(new VueSocketIO({
    debug: process.env.NODE_ENV === 'development',
    connection: SocketIO(process.env.VUE_APP_WS_HOST, {
        path: process.env.VUE_APP_WS_PATH,
    }),
}))

Vue.use(Notifications);
Vue.use(VModal);
Vue.use(VueCookies);
Vue.use(Meta, {
    refreshOnceOnNavigation: true,
});


Vue.filter('pluralForm', (value, forms) => Helper.pluralForm(value, forms));
Vue.filter('dateFormatTimestamp', (value, format = 'fullDate', utc = undefined) => dateFormat((new Date()).setTime(value * 1000), format, utc));
Vue.filter('dateFormat', (value, format = 'fullDate', utc = undefined) => dateFormat(value, format, utc));
Vue.filter('numberFormat', (value, decimals, dec_point = '.', thousands_sep = ' ') => {
    if (isNaN(value) === true) {
        return value;
    }
    return numberFormat(value, decimals, dec_point, thousands_sep);
});
Vue.filter('moment', (value, format, sourceFormat = undefined) => {
    return typeof value === 'number' ? moment(value * 1000).format(format) : moment(value, sourceFormat).format(format);
});
Vue.filter('duration', (value) => {
    let days = Math.floor(value / 86400)
    let hours = Math.floor((value - (days * 86400)) / 3600);
    let minutes = Math.floor((value - (hours * 3600) - (days * 86400)) / 60);
    let seconds = Math.floor(value - ((hours * 3600) + (minutes * 60) + (days * 86400)));
    let result = '';
    if (days > 0) {
        result += `${days} ${Helper.pluralForm(days, ['день', 'дня', 'дней'])} `
    }
    if (hours > 0) {
        result += `${hours} ${Helper.pluralForm(hours, ['час', 'часа', 'часов'])} `;
    }
    if (minutes > 0) {
        result += `${minutes} ${Helper.pluralForm(minutes, ['минута', 'минуты', 'минут'])} `;
    }
    if (seconds > 0) {
        result += `${seconds} ${Helper.pluralForm(seconds, ['секунда', 'секунды', 'секунд'])} `;
    }

    return result;
});


Vue.config.productionTip = false;

import './assets/css/fonts.css';
import './assets/css/bootstrap.css';
import './assets/vendor/plugins/fullcalendar/fullcalendar.min.css';
import './assets/skin/default_skin/css/theme_new.css';
import './assets/skin/default_skin/css/font-awesome-animation.min.css';
import './assets/admin-tools/admin-forms/css/admin-forms.min.css';
import './assets/vendor/plugins/datatables/media/css/dataTables.bootstrap.css';
import './assets/css/buttons.bootstrap.min.css';
import './assets/css/progress.css';
import 'vue-select/dist/vue-select.css';
import './assets/css/app.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-cal/dist/vuecal.css';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import './assets/css/custom.css';

new Vue({
    router,
    store,
    render: h => h(App),
    data()  {
        return {
            appName: 'DanceERM',
        }
    },
    metaInfo() {
        return {
            title: '',
            titleTemplate: (titleChunk) => {
                return titleChunk ? `${titleChunk} - ${this.appName}` : this.appName;
            },
            meta: [
                {vmid: 'description', name: 'description', content: ''},
                {vmid: 'keywords', name: 'keywords', content: ''},
            ],
        };
    },
}).$mount('#app');
